// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
// Configure any UI based settings/variables

$(function () {
  // Touch/no-touch detection
  var isTouch = "ontouchstart" in window || navigator.msMaxTouchPoints > 0
  $("html").toggleClass("touch", isTouch)
  $("html").toggleClass("no-touch", !isTouch)
})
